export default "__VITE_ASSET__BmwWQU2h__";